import {
  getOrCreateClientCache
} from "./../helpers/composables.js";
import { isRef, unref } from "vue";
import { performRequest } from "./nuxtApp.js";
import {
  clientOptions
} from "#nuxt-graphql-middleware/client-options";
import { useAsyncData, useAppConfig, useNuxtApp, computed } from "#imports";
import { hash } from "ohash";
import { importMetaClient } from "#nuxt-graphql-middleware/config";
export function useAsyncGraphqlQuery(name, ...args) {
  const variables = args[0];
  const asyncDataOptions = args[1] || {};
  const asyncDataKey = computed(() => {
    const vars = isRef(variables) ? variables.value : variables;
    return `useAsyncGraphqlQuery:${name}:${hash(vars)}`;
  });
  let prevKey = "";
  const config = useAppConfig();
  const app = useNuxtApp();
  if (importMetaClient) {
    if (variables && isRef(variables)) {
      if (!asyncDataOptions.watch) {
        asyncDataOptions.watch = [];
      }
      asyncDataOptions.watch.push(variables);
    }
    if (asyncDataOptions.graphqlCaching?.client && app.isHydrating) {
      const cache = getOrCreateClientCache(app, config);
      if (cache) {
        const key = asyncDataKey.value;
        const payload = app.payload.data[asyncDataKey.value];
        if (payload) {
          cache.set(key, payload);
        }
      }
    }
    if (asyncDataOptions.graphqlCaching?.client && !asyncDataOptions.getCachedData) {
      asyncDataOptions.getCachedData = function(key, app2, ctx) {
        if (ctx.cause === "initial") {
          return app2.payload.data[key] ?? app2.$graphqlCache?.get(key);
        } else if (ctx.cause === "refresh:manual" || ctx.cause === "refresh:hook") {
          if (app2.$graphqlCache) {
            app2.$graphqlCache.purgeAsyncDataKey(key);
            app2.$graphqlCache.purgeAsyncDataKey(prevKey);
          }
        }
      };
    }
  }
  const result = useAsyncData(
    asyncDataKey.value,
    () => {
      prevKey = asyncDataKey.value;
      const globalClientContext = clientOptions && clientOptions.buildClientContext ? clientOptions.buildClientContext() : {};
      return performRequest(
        "query",
        name,
        unref(variables) || {},
        asyncDataOptions.fetchOptions || {},
        globalClientContext,
        asyncDataOptions.clientContext || {},
        asyncDataOptions.graphqlCaching || {},
        asyncDataKey.value
      );
    },
    asyncDataOptions
  );
  if (import.meta.hot) {
    import.meta.hot.on("nuxt-graphql-middleware:reload", (data) => {
      if (data.operations.includes(name)) {
        result.refresh();
      }
    });
  }
  return result;
}
